module.exports = __webpack_public_path__ + "assets/Attempt.3b64dbb9.svg";